import { render, staticRenderFns } from "./TransactionConfigEdit.vue?vue&type=template&id=29d04d8b&scoped=true&"
import script from "./TransactionConfigEdit.vue?vue&type=script&lang=js&"
export * from "./TransactionConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d04d8b",
  null
  
)

export default component.exports